import { useEffect } from "react";
import { Grid } from "@pankod/refine-mui";
import { useSelect } from "@pankod/refine-core";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  setFieldsSettings,
}) {
  const { options: postsAC } = useSelect({
    resource: "posts",
    optionLabel: "title",
    optionValue: "id",
  });

  const { options: linksAC } = useSelect({
    resource: "links",
    optionLabel: "title",
    optionValue: "id",
  });

  const { options: videosAC } = useSelect({
    resource: "videos",
    optionLabel: "title",
    optionValue: "id",
  });

  const fields = [
    {
      label: "Gallery",
      name: "gallery",
      required: true,
      type: "gallery",
      width: "100%",
      height: 900,
      elevation: 0,
      md: 8,
    },
    {
      type: "space",
      height: "3em",
    },
    {
      type: "text",
      name: "title",
      label: "Title",
      localized: true,
    },
    {
      label: "Posts",
      name: "posts",
      required: true,
      type: "multi-select",
      options: postsAC,
    },
    {
      label: "Links",
      name: "links",
      required: true,
      type: "multi-select",
      options: linksAC,
    },
    {
      label: "Videos",
      name: "videos",
      required: true,
      type: "multi-select",
      options: videosAC,
    },
    {
      type: "space",
      height: "3em",
    },
    {
      label: "Content",
      name: "content",
      required: true,
      type: "editor",
      localized: true,
    },
  ];

  useEffect(() => {
    setFieldsSettings(fields);
  }, []);

  return (
    <Grid container spacing={2} justifyContent="center">
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
